import React, { Component } from "react";
import { Input, Button, Modal, message } from "antd";
import { parse } from "qs";
import { connect } from "dva";
import Container from "../../../../../components/Container";
import ListPage from "../../../../../components/ListPage";
import SelectSupervise from "../components/SelectSuperviseModal";
import OperateDropdown from "../../../../../components/OperateDropdown";
import styles from "./index.less";

const { Search } = Input;
const { warning, confirm } = Modal;
const { ListTable } = ListPage;

@connect(({ projectTarget, projectDetail }) => ({
  ...projectTarget,
  projectInfo: projectDetail.projectInfo
}))
class TargetView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTarget: null
    };

    const columns = [
      {
        title: "督查对象",
        dataIndex: "orgName",
        width:'85%'
      },
      {
        title: "操作",
        dataIndex: "",
        width:'15%',
        render: record => {
          const data = [
            {
              text: (
                <a onClick={event => this.handleDeleteOne({ record, event })}>
                  删除
                </a>
              )
            }
          ];
          return <OperateDropdown data={data} />;
        }
      }
    ];
    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId } = query;

    this.state = {
      columns,
      currentProjectId,
      showSelectUser: false
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch({
      type: "projectTarget/save",
      payload: {
        selectedRespondentRowKeys: []
      }
    });
  }

  componentDidMount() {
    this.getList();
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const params = { page, pageSize };
    this.getList(params);
  };

  getList = pageInfo => {
    // 获取列表
    const { currentProjectId, searchTarget } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectTarget/fetchRespondentList",
      payload: {
        projectId: currentProjectId,
        param: searchTarget,
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  // 显示选择督查对象显示列表
  handleShowSupervise = () => {
    this.setState(
      {
        showSelectUser: true
      },
      () => {
        this.handleGetSuperviseList();
      }
    );
  };

  // 获取督查对象列表
  handleGetSuperviseList = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectTarget/fetchGetSuperviseList",
      payload: {
        projectId: currentProjectId,
        param: ""
      }
    });
  };

  // 添加督查对象
  handleSetSupervise = selectedList => {
    const { currentProjectId } = this.state;
    const { dispatch, projectInfo } = this.props;
    const { processStatus } = projectInfo;
    if (processStatus === 10) {
      dispatch({
        type: "projectTarget/fetchAddRespondentList",
        payload: {
          respondOrgList: selectedList,
          projectId: currentProjectId
        },
        callback: this.getList
      });
      this.setState({
        showSelectUser: false
      });
    } else {
      warning({
        title: "提示",
        content: "项目已开始，不能添加",
        okText: "确认"
      });
    }
  };

  handleDeleteOne = ({ record, event }) => {
    if (event) {
      event.stopPropagation();
    }
    const { orgId } = record;
    const { dispatch, projectInfo } = this.props;
    const { processStatus } = projectInfo;
    const { currentProjectId } = this.state;
    // delete
    if (processStatus === 10) {
      confirm({
        title: "删除",
        content: "确定删除选择的督查对象吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          dispatch({
            type: "projectTarget/fetchDeleteRespondent",
            payload: {
              projectId: currentProjectId,
              orgIds: [orgId]
            },
            callback: () => {
              this.getList();
              dispatch({
                type: "projectTarget/save",
                payload: {
                  selectedRespondentRowKeys: []
                }
              });
            }
          });
        }
      });
    } else {
      warning({
        title: "提示",
        content: "项目已开始，不能删除",
        okText: "确认"
      });
    }
  };

  handleDelete = () => {
    const { currentProjectId } = this.state;
    const { selectedRespondentRowKeys, dispatch, projectInfo } = this.props;
    const { processStatus } = projectInfo;
    if (!selectedRespondentRowKeys || selectedRespondentRowKeys.length === 0) {
      message.error("请至少选中一个督查对象");
      return false;
    }
    if (processStatus === 10) {
      confirm({
        title: `批量删除`,
        content: "确定删除选中的督查对象吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          dispatch({
            type: "projectTarget/fetchDeleteRespondent",
            payload: {
              projectId: currentProjectId,
              orgIds: selectedRespondentRowKeys
            },
            callback: () => {
              this.getList();
              dispatch({
                type: "projectTarget/save",
                payload: {
                  selectedRespondentRowKeys: []
                }
              });
            }
          });
        }
      });
    } else {
      warning({
        title: "提示",
        content: "项目已开始，不能删除",
        okText: "确认"
      });
    }
    // 删除接口
    return false;
  };

  handleChangeSelected = (selectedRespondentRowKeys, selectedRows) => {
    const { dispatch } = this.props;
    // 把选中的 selectedRowKeys 放入 store 中
    dispatch({
      type: "projectTarget/save",
      payload: {
        selectedRespondentRowKeys
      }
    });
  };

  handleSearch = val => {
    this.setState(
      {
        searchTarget: val
      },
      () => {
        this.getList();
      }
    );
  };

  onCancel = () => {
    this.setState({
      showSelectUser: false
    });
  };

  renderHeader = () => {
    return (
      <div className="header">
        <div className="btn-wrap">
          <Button onClick={this.handleShowSupervise} type="primary">
            + 添加督查对象
          </Button>
          <Button onClick={this.handleDelete}>批量删除</Button>
        </div>
        <Search
          style={{ width: 300 }}
          placeholder="搜索督查对象名称"
          onSearch={this.handleSearch}
        />
      </div>
    );
  };

  render() {
    const { columns, showSelectUser } = this.state;

    const {
      spinProps,
      selectedRespondentRowKeys,
      respondentOrgList,
      superviseList,
      pageInfo
    } = this.props;

    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };

    const pageProps = {
      spinProps,
      className: styles.target
    };

    const tableProps = {
      columns,
      rowKey: "orgId",
      list: respondentOrgList,
      rowSelection: {
        selectedRowKeys: selectedRespondentRowKeys,
        onChange: this.handleChangeSelected
      },
      pageInfo,
      onPageChange: this.handlePaginationChange
    };
    return (
      <Container {...containerProps}>
        <ListPage {...pageProps}>
          <div className="container">
            {this.renderHeader()}
            <ListTable {...tableProps} />
          </div>
          {showSelectUser && (
            <SelectSupervise
              superviseList={superviseList}
              onOk={this.handleSetSupervise}
              onCancel={this.onCancel}
            />
          )}
        </ListPage>
      </Container>
    );
  }
}

export default TargetView;
